<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container pt-4">
            <button
                class="h-11 w-44 rounded bg-main hover:bg-hoverMain focus:ring-0 z-40 text-white font-bold border-0"
                @click="$i18nHelper.toUrl('incomeAndOutcome/add')"
            >
                {{ $t('new') }}
            </button>

            <SearchCollapse :is-bg-white="true" class="">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                    <div class="md:col-span-3 btn-group btn-group-toggle flex justify-content-around" data-toggle="buttons">
                        <label class="btn btn-primary button-stat active font-bold flex align-items-center justify-content-center">
                            <input type="radio" v-model="search.isIncome" @click="search.isIncome = null" name="options" checked>{{ $t('filter.all') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isIncome" @click="search.isIncome = true" name="options">{{ $t('incomeAndOutcome.income') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isIncome" @click="search.isIncome = false" name="options">{{ $t('incomeAndOutcome.outlay') }}
                        </label>
                    </div>

                    <div class="md:col-span-1">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-9 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchFilters">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-9 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductPurchaseSearchInfo">
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.thisDay') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="after"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toDay') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="before"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>
                </div>
            </SearchCollapse>
        </div>

        <table class="w-full mt-2">
            <thead>
                <tr class="bg-lightGray h-11 font-bold">
                    <th class="d-none d-md-table-cell pl-3">#</th>
                    <th class="d-none d-md-table-cell">{{ $t('date') }}</th>
                    <th>{{ $t('category') }}</th>
                    <th class="d-none d-xl-table-cell text-center">{{ $t('productsInWarehouse.reason') }}</th>
                    <th>{{ $t('sale.sum') }}</th>
                    <th class="d-none d-md-table-cell">{{ $t('finance.balance') }}</th>
                    <th>{{ $t('finance.count') }}</th>
                    <th>{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="(incomeAndOutcome, index ) of getIncomeAndOutcomes" :key="index" class="h-11">
                <td class="d-none d-md-table-cell pl-3">
                    {{index + 1}}
                </td>
                <td class="d-none d-md-table-cell">
                    {{ dateTimeFormat(incomeAndOutcome.createdAt, true) }}
                </td>
                <td  v-if="incomeAndOutcome.companyCount !== null">
                    <span v-if="incomeAndOutcome.isIncome === null">
                        {{ $t('finance.transfer') }}
                    </span>
                    <span v-else>
                        {{ getNameCategory(incomeAndOutcome.category.name) }}
                    </span>
                </td>
                <td v-else>
                    <span class="pl-4">&#8213;</span>
                </td>
                <td class="d-none d-xl-table-cell text-center">
                    {{incomeAndOutcome.reason}}
                </td>
                <td class="w-44">
                    <div class="py-1 rounded text-center inline-block" :style="`background-color: ${howBgColor(incomeAndOutcome.isIncome)}`">
                        {{ getSum(showCurrencyById(incomeAndOutcome.sumCurrency.id, incomeAndOutcome.sum), incomeAndOutcome.isIncome) }}
                    </div>
                </td>
                <td class="d-none d-md-table-cell">
                    {{ showCurrencyById(incomeAndOutcome.sumCurrency.id, incomeAndOutcome.countBalanceStatus) }}
                </td>
                <td v-if="incomeAndOutcome.companyCount !== null">
                    <span
                        class="py-1 px-2 rounded"
                        v-if="incomeAndOutcome.companyCount.name === 'Main'"
                        :style="`background-color: ${backgroundColor(incomeAndOutcome.isIncome)}`"
                    >
                        {{$t('main')}}
                        <span v-if="incomeAndOutcome.isIncome === null">
                            <span class="align-top">&#10230;</span>  {{incomeAndOutcome.whichCount.name}}
                        </span>
                    </span>
                    <span
                        class="py-1 px-2 rounded"
                        v-else
                        :style="`background-color: ${backgroundColor(incomeAndOutcome.isIncome)}`"
                    >
                        {{incomeAndOutcome.companyCount.name}}
                        <span v-if="incomeAndOutcome.isIncome === null && incomeAndOutcome.whichCount.name === 'Main'">
                            <span class="mb-2">&#10230;</span>  {{$t('main')}}
                        </span>
                        <span v-if="incomeAndOutcome.isIncome === null && incomeAndOutcome.whichCount.name !== 'Main'">
                            <span class="mb-2">&#10230;</span>  {{incomeAndOutcome.whichCount.name}}
                        </span>
                    </span>
                </td>
                <td v-else>
                    <span class="pl-3">&#8213;</span>
                </td>
                <td>
                    <img src="/images/edit.png" @click="$i18nHelper.toUrl('incomeAndOutcome/' + incomeAndOutcome.id)" alt="" class="h-6 pr-1 cursor-pointer">
                    <img src="/images/Union.png" @click="deleteIncome(incomeAndOutcome.id)" alt="" class="h-6 cursor-pointer">
                </td>
            </tr>
            </tbody>
        </table>
        <div class="row">
            <div class="col mt-4 ml-4">
                <Pagination
                    :search="search"
                    base-url="incomeAndOutcomes"
                    :total-items="getIncomeAndOutcomesTotalCount"
                    method-name="searchIncomeAndOutcome"
                />
            </div>
        </div>
    </Row>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import {mapActions, mapGetters} from "vuex";
import SearchCollapse from "@/components/SearchCollapse";
import Pagination from "@/components/html/Pagination";
import Row from "@/components/html/Row.vue";
import InputBox from "@/components/InputBox.vue";

export default {
    name: "List",
    components: {
        InputBox,
        Row,
        Pagination,
        SearchCollapse
    },
    mixins: [currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            page: 1,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'finance.title', url: 'companyCount'},
                {name: 'incomeAndOutcome.title'},
            ],
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('incomeAndOutcome.income'), value: true},
                {text: this.$t('incomeAndOutcome.outlay'), value: false}
            ],
            search: {
                isIncome: null,
                after: '',
                before: '',
                page: 1
            },
        }
    },
    computed: {
        ...mapGetters([
            'getIncomeAndOutcomes',
            'getIncomeAndOutcomesTotalCount',
        ]),
    },
    methods: {
        ...mapActions([
            'fetchIncomeAndOutcomes',
            'searchIncomeAndOutcome',
            'deleteIncomeAndOutcome',
            'setBreadcrumbItems'
        ]),
        deleteIncome(id) {
            this.$root.showOverlay = true
            this.deleteIncomeAndOutcome(id)
                .then(() => {
                    this.fetchIncomeAndOutcomes(this.search)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        getNameCategory(categoryName) {
            switch (categoryName) {
                case "sale":
                case "purchase":
                case "rent":
                case "salary":
                case "communal":
                case "debt":
                case "credit":
                case "paymentSystem":
                    return this.$t("finance.income." + categoryName)

                default:
                    return categoryName
            }
        },
        backgroundColor(isIncome) {
            if(isIncome === null) {
                return ' '
            }

            return isIncome ? '#D4F8E5' : '#FFCDB8'
        },
        getSum(sum, isIncome) {
            if(isIncome === null) {
                return sum
            }

            return isIncome ? '+' + sum : '-' + sum
        },
        searchFilters() {
            this.$root.showOverlay = true
            this.searchIncomeAndOutcome(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductPurchaseSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchFilters()
        },
        howBgColor(isIncome) {
            return isIncome ? '#D4F8E5' : '#FFCDB8'
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchIncomeAndOutcomes(this.search)
    },
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    height: 35px;
    width: 100px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}
</style>